import { createFileRoute } from "@tanstack/react-router";
import FaqPage from "@/components/FaqPage";
import { buildHead, breadcrumbLD } from "@/content/seo";
import { faqExpandedLD, boatingBusinessLD } from "@/content/faq-expanded";

const TITLE = "FAQ — Charter Privado de Iate Vilamoura | Morningstar";
const DESC =
  "Respostas a todas as perguntas sobre charter privado de iate na Marina de Vilamoura a bordo do Morningstar — reserva, iate, inclusões, upgrades, logística e meteorologia.";
const PATH = "/pt/faq";

export const Route = createFileRoute("/pt/faq")({
  component: () => <FaqPage lang="pt" />,
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "faq charter iate vilamoura, marina de vilamoura embarque, perguntas morningstar, aluguer barco vilamoura faq, gruta benagil cruzeiro faq",
      altPath: { en: "/faq", pt: PATH },
      extraScripts: [
        { type: "application/ld+json", children: JSON.stringify(faqExpandedLD("pt")) },
        { type: "application/ld+json", children: JSON.stringify(boatingBusinessLD()) },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "FAQ", path: PATH },
            ]),
          ),
        },
      ],
    }),
});